import { DocumentStatus } from 'DocumentStatus';
import FundOpportunity from '../../../models/FundOpportunity';

export type WizardDocumentStatus = DocumentStatus & { encryptedDocumentUrl?: string };

export type WizardStep = 'initial' | 'documentCheck' | 'uploadAndGenerate' | 'success';

export interface WizardState {
  step: WizardStep;
  useAI: boolean;
  documents: WizardDocumentStatus[];
  selectedDocuments: WizardDocumentStatus[];
  newFiles: DocumentStatus[];
  filesForUpload: File[];
  isUploading: boolean;
  isCheckingDocuments: boolean;
  error: string | null;
}

export interface AIAssistedCreationWizardProps {
  open: boolean;
  fundOpportunity: FundOpportunity;
  onNavigateToContent: () => void;
  onExit: () => void;
  standalone?: boolean;
}

export function createInitialWizardState(standalone: boolean): WizardState {
  return {
    step: standalone ? 'uploadAndGenerate' : 'initial',
    useAI: standalone,
    documents: [],
    selectedDocuments: [],
    newFiles: [],
    filesForUpload: [],
    isUploading: false,
    isCheckingDocuments: false,
    error: null,
  };
}
